import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { cn } from '@/lib/utils'

interface SegmentedControlProps<T extends string> {
  value: T
  onValueChange: (value: T) => void
  options: { value: T; label: React.ReactNode; testId?: string }[]
  'aria-label'?: string
  className?: string
}

/** Pill-style switcher built on `Tabs`, so keyboard navigation and ARIA roles
 * stay in one place. */
function SegmentedControl<T extends string>({
  value,
  onValueChange,
  options,
  className,
  ...props
}: SegmentedControlProps<T>) {
  return (
    <Tabs value={value} onValueChange={(next) => onValueChange(next as T)} className={className}>
      <TabsList
        aria-label={props['aria-label']}
        className="bg-secondary h-10 rounded-xl p-1 max-md:h-13"
      >
        {options.map((option) => (
          <TabsTrigger
            key={option.value}
            value={option.value}
            aria-controls={undefined}
            data-testid={option.testId}
            className={cn('tap-target h-8 flex-1 rounded-lg px-3.5 text-sm')}
          >
            {option.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  )
}

export { SegmentedControl }
